import React, { useRef } from 'react';
import classNames from 'classnames';
import analytics from '@common/utils/analytics';
import ColorSwatch from './ColorSwatch';
import { useTranslation } from 'react-i18next';
const ProductSelectionColorRadioLinks = (props) => {
    const hiddenColours = props.variationValues.length - props.swatchLenght;
    const { t } = useTranslation();
    const linkRefs = useRef([]);
    const radioGroupId = `select-color-tile-${props.product.uuid}`;
    const colorName = (variation) => {
        return (React.createElement("span", { "aria-hidden": "true", className: classNames('selector__menu__item__label', { 'has-hidden-colors': hiddenColours >= 1 }) }, variation.displayValue));
    };
    const handleLinkSelect = (index) => {
        props.onChangeVariation(props.variationValues[index]);
        linkRefs.current[index].focus();
    };
    // Manage keyboard navigation, leaving tab key out of this, in order to mockup a radio group behavior
    const handleKeyDown = (e, index) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            const nextIndex = (index + 1) % linkRefs.current.length;
            handleLinkSelect(nextIndex);
        }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            const prevIndex = (index - 1 + linkRefs.current.length) % linkRefs.current.length;
            handleLinkSelect(prevIndex);
        }
        else if (e.key === 'Enter') {
            handleLinkSelect(index);
        }
    };
    const isVariationOutOfStock = (variation) => {
        return !variation.selectable && !props.isComingSoon && !variation.isBoutiqueExclusive;
    };
    return (React.createElement("fieldset", { className: "selector__menu inverted", role: "radiogroup", "aria-labelledby": radioGroupId },
        React.createElement("div", { id: radioGroupId, className: "visually-hidden" }, t('exchanges.changecolor')),
        props.variationValues.map((variation, index) => (React.createElement("div", { key: variation.id },
            React.createElement("legend", { className: "visually-hidden" }, t('exchanges.changecolora11y')),
            index < props.swatchLenght ? (React.createElement("a", { role: "radio", href: variation.productUrl, "aria-checked": variation.value == props.currentId, "aria-label": variation.displayValue, className: classNames('selector__menu__item selector__menu__item--link', variation.value == props.currentId && 'selected', isVariationOutOfStock(variation) && 'is-disabled'), onClick: (e) => {
                    var _a;
                    e.preventDefault();
                    props.onChangeVariation(variation);
                    analytics.colorSelection(variation === null || variation === void 0 ? void 0 : variation.id, (_a = variation === null || variation === void 0 ? void 0 : variation.productId) === null || _a === void 0 ? void 0 : _a.replace(variation.id, ''), props.tileType);
                }, tabIndex: variation.value == props.currentId ? 0 : -1, onKeyDown: (e) => handleKeyDown(e, index), ref: (el) => (linkRefs.current[index] = el) },
                props.showColorName && colorName(variation),
                React.createElement(ColorSwatch, { variation: variation, stroke: isVariationOutOfStock(variation), ariaHidden: true }))) : (React.createElement(React.Fragment, null, index + 1 == props.variationValues.length && React.createElement("div", { "aria-label": t('label.colorsa11y') },
                "+",
                hiddenColours))))))));
};
export default ProductSelectionColorRadioLinks;
